import React from 'react'

export const QuestionIcon = () => (
  <svg width="40" height="40">
    <g fill="none" fillRule="evenodd">
      <rect width="40" height="40" fill="#FFF" fillOpacity=".8" rx="16" />
      <path d="M8 8h24v24H8z" />
      <path
        fill="#AB9F94"
        d="M20.503 25.35a1 1 0 011 1V27a1 1 0 01-1 1h-.65a1 1 0 01-1-1v-.65a1 1 0 011-1h.65zM19.981 12c3.366 0 6.01 2.587 6.01 5.925 0 3.339-2.644 5.926-6.01 5.926h-1.669v-2.198h1.67c2.113 0 3.643-1.613 3.643-3.728 0-2.114-1.53-3.727-3.644-3.727-2.142 0-3.616 1.613-3.616 3.727H14C14 14.587 16.615 12 19.981 12z"
      />
    </g>
  </svg>
)
